import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import AnalyticsClick from '~/components/Shared/Analytics/AnalyticsClick';
import HeaderQuoteIcon from '~/icons/headerQuote';
import OnSIIcon from '~/icons/onSIIcon';
import type { SectionHeaderBlockInterface } from '~/types/AppData/PageBuilder/SectionHeaderBlockInterface';
import AnalyticsContainer from '~/components/Shared/Analytics/AnalyticsContainer';
import { getOneIndexing } from '~/utilities/getOneIndexing';

const dividerClasses = cva('', {
  variants: {
    link: {
      true: '',
      false: '',
    },
    branding: {
      '': 'border-borderGrey mt-1',
      onSI: '!border-primary h-2.5 bg-primary',
    },
  },
  defaultVariants: {
    branding: '',
  },
  compoundVariants: [
    {
      link: false,
      branding: 'onSI',
      className: 'mt-[18px]',
    },
  ],
});

export default component$<
  SectionHeaderBlockInterface['props'] & { index: number }
>(({ title, link, showDivider, showQuote, branding, index }): JSX.Element => {
  return (
    <AnalyticsContainer
      component_name={`SectionHeader-${getOneIndexing(index)}`}
      component_type='SectionHeader'
      component_placement={getOneIndexing(index)}
    >
      <div class='w-full group-[&.gallery-column]:pb-5'>
        <div class='relative flex justify-between items-baseline'>
          {!branding && (
            <div class='flex items-center gap-2.5'>
              {showQuote && <HeaderQuoteIcon cssClasses='mb-[5px]' />}
              <h2 class='font-group-large'>{title}</h2>
            </div>
          )}
          {branding === 'onSI' && (
            <div>
              <OnSIIcon cssClasses='absolute top-[2px] left-[5px]' />
            </div>
          )}

          {link?.text && link.url && (
            <AnalyticsClick
              click_link_url={link.url}
              link_position={getOneIndexing(index)}
            >
              <a
                class='header-link hover:underline'
                href={link.url}
                target={link.target}
              >
                <h4 class='font-group-tiny'>{link.text}</h4>
              </a>
            </AnalyticsClick>
          )}
        </div>
        {showDivider && (
          <hr class={dividerClasses({ branding, link: !!link?.text })} />
        )}
      </div>
    </AnalyticsContainer>
  );
});
